import axios from 'axios';
import store, {_closeSession, _gatherEntitlements} from '../store';
import {NODEJS_API_URL} from '../../config.json';
import {formatter} from './utils';
import getContext from '../../advisor/utils/defaultContext';
import history from '../../history';

const phone = formatter('phone');

const localAuth = {};

export const setAuth = (token, portal = 'advisor') => {
  localAuth.saml = 'Bearer ' + token;
  localAuth.portal = portal;

  store.dispatch(_gatherEntitlements(false, true));
  return new Promise(function checkSession(resolve, reject) {
    let count = 0;
    const timer = setInterval(() => {
      const state = store.getState();
      if (state.session.profile && state.session.profile.id) {
        window.clearInterval(timer);
        return resolve(state.session);
      }
      if (count >= 200) {
        window.clearInterval(timer);
        return reject(new Error('Failed to authenticate'));
      }
    }, 100);
  })
    .then(session => getContext(session)
      .then(con => ({context: con, user: session.profile})));
};

// TODO remove before product-izing
export const setInternalAuth = (email, token, portal = 'advisor') => {
  localAuth.portal = portal;
  localAuth.email = email;
  localAuth.token = token;

  store.dispatch(_gatherEntitlements(false, true));
  return new Promise(function checkSession(resolve, reject) {
    let count = 0;
    const timer = setInterval(() => {
      const state = store.getState();
      if (state.session.profile && state.session.profile.id) {
        window.clearInterval(timer);
        return resolve(state.session);
      }
      if (count >= 200) {
        window.clearInterval(timer);
        return reject(new Error('Failed to authenticate'));
      }
    }, 100);
  })
    .then(session => getContext(session)
      .then(con => ({context: con, user: session.profile})));
};

const axiosInstance = axios.create({
  baseURL: NODEJS_API_URL,
  timeout: 59000,
});

const handlers = {
  standard: (request) => {
    request.headers['cb-portal'] = localAuth.portal || localStorage.portal;

    if (localAuth.saml) {
      request.headers.Authorization = localAuth.saml;
    } else {
      request.headers['cb-token'] = localAuth.token || localStorage.token;
      request.headers['cb-email'] = localAuth.email || localStorage.email;
    }

    if (localStorage.runAs && !request.runAsSelf) {
      request.headers['cb-run-as'] = request.headers['cb-run-as'] || localStorage.runAs;
    }

    if (localStorage.runAsInvestor) {
      request.headers['cb-run-as'] = request.headers['cb-run-as'] || localStorage.runAsInvestor;
    }
    return request;
  },
  success: response => response,
  failure: rejection => {
    if (rejection?.code === 'ECONNABORTED') {// This is a timeout
      const brand = store.getState()?.product?.brand;
      if (rejection?.config?.method === 'GET') {
        throw Object({
          code: 'ETIMEOUT',
          msg: `We're sorry, the requested data is taking longer than expected to load. Please try refreshing the page. If the issue persists please contact us at ${brand.clientServicesEmail} or ${phone(
            brand.clientServicesPhone
          )}.`,
          title: 'Request Taking Too Long',
        });
      }
      throw Object({
        code: 'ETIMEOUT',
        msg: `We're sorry, the action you attempted is taking longer than expected. Please check back after some time. If the issue persists please contact us at ${brand.clientServicesEmail} or ${phone(
          brand.clientServicesPhone
        )}.`,
        title: 'Request Taking Too Long',
      });
    }
    if (rejection?.response?.data?.error
      && ([110, 111, 112].indexOf(rejection.response.data.error.code) >= 0)) {
      store.dispatch(_closeSession({skipAPICall: true}));
    } else if (rejection?.response?.data?.error
      && ([116].indexOf(rejection.response.data.error.code) >= 0)) {
      history.push('/firstLogin/terms');
    }
    throw Object({...rejection});
  },
};

axiosInstance.interceptors.response.use(
  response => handlers.success(response),
  error => handlers.failure(error)
);

axiosInstance.interceptors.request.use(
  request => handlers.standard(request)
);

export default axiosInstance;
